/**
 * author: Soumya Shreyas
 */
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { Modal, Form } from "react-bootstrap";
import { BiFile, BiPlus } from "react-icons/bi";
import FormService from "../../core/services/FormService";
import { ASSESSMENTFORMTXT, FORMTYPES, GENERAL_FORM, SCORINGMETHODS, startYear } from "../../core/constants/common";
import { FormContext } from "../../App";
import Multiselect from "multiselect-react-dropdown";
import { version } from "typescript";

function FormCreate({ isRename, form, callbackFn }) {
  const navigate = useNavigate();
  const formObj = useContext(FormContext);
  const [show, setShow] = useState(isRename ? true : false);
  const [validated, setValidated] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [selLang, setSelLanguage] = useState(isRename ? form.languages[0].id : "");
  const [formName, setFormName] = useState(isRename ? form.name : "");
  const [formDesc, setFormDesc] = useState(isRename ? form.description : "");
  const [id, setId] = useState(formObj ? formObj[0]?.id : "");
  const [formTypeVal, setFormTypeVal] = useState(isRename
    ? form.selfAssessment
      ? (form.formType === 'SURVEY' ? 'MATERIALITY' : 'SELFASSESSMENT')
      : 'SUPPLIERASSESSMENT'
    : '');
  const [scoringmethod, setScoringMethod] = useState(isRename ? form.scoringMethod : "NONE");
  const [historicalDataSupported, setHistoricalDataSupported] = useState(form?.historicalDataSupported ?? false);
  const [historicalDataYears, setHistoricalDataYears] = useState(form?.historicalDataYears ?? []);
  const [yearOptions, setYearOptions] = useState([]);	
  const [reviewRequired, setReviewRequired] = useState(isRename ? form.reviewRequired : false);
  const currentYear = new Date().getFullYear();

  let renameId = "";
  if (isRename) {
    renameId = form.id;
  }
  useEffect(() => {
    setId(formObj ? formObj[0]?.id : "");
    id && setFormTypeVal(formObj ? formObj[0]?.selfAssessment ? 'SELFASSESSMENT' : 'SUPPLIERASSESSMENT' : "");
    id && setShow(true);
    getLanguages();
  }, [formObj]);

  useEffect(() => {
    let options = [];
    for (let i = currentYear; i >= startYear; i--) {
      options.push({
        value: i,
        displayValue: i
      });
    }
    setYearOptions(options);
  }, []);

  const handleClose = () => {
    setShow(false);
    isRename && callbackFn(false);
  };
  const handleShow = () => setShow(true);

  const getLanguages = () => {
    FormService.getLanguages()
      .then((response) => {
        setLanguages(response.data);
      })
      .catch((error) => {
        console.log("err", error);
      });
  };
  const handleCreateForm = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      if (historicalDataSupported && historicalDataYears?.length > 5) {
        toast.error('Not allowed to record historical data for more than 5 years', {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000
        });
        return;
      }      
      if (isRename) {
        let params = {
          name: formName,
          description: formDesc,
          scoringMethod: scoringmethod,
          reviewRequired: reviewRequired,
          historicalDataSupported: historicalDataSupported,
          historicalDataYears: historicalDataYears 
        };
        renameForm(params);
      } else {
        const params = {
          name: formName,
          description: formDesc,
          formType: formTypeVal,
          selectedLanguage: {
            id: selLang,
          },
          scoringMethod: scoringmethod,
          historicalDataSupported: historicalDataSupported,
          historicalDataYears: historicalDataYears
        };
        if (formObj[0]?.id) {
          params["extraParam"] = formObj[0]?.id;
        }
        createForm(params);
      }
    }
    setValidated(true);
  };
  const createForm = (params) => {
    FormService.createForm(params)
      .then((response) => {
        if (response.status === 201) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setShow(false);
          // callbackCreate(response.data.id);
          // navigate('/form_builder/form_edit/:id/:langId');
          let id = response.data.id;
          let langId = response.data.languages[0].id;
          navigate({
            pathname: `/form_builder/form_edit/${id}/${langId}`,
          });
        }
      })
      .catch((error) => {
        let errormsg = error.response.data.message ? error.response.data.message : error.message;
        toast.error(errormsg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };
  const renameForm = (params) => {
    FormService.renameForm(renameId, params)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Success", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setShow(false);
          isRename && callbackFn(false);
        }
      })
      .catch((error) => {
        let errormsg = error.response.data.message ? error.response.data.message : error.message;
        toast.error(errormsg, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

	const getSelectedYears = () => {
		const data = [];
		historicalDataYears?.forEach(y => {		
			data.push({
        value: y,
        displayValue: y
      });
		});
		return data;
	};

  const onSelectDeSelectYear = (d) => {
    const h = [...historicalDataYears];
    const index = h.indexOf(d.value);
    if (index >= 0) {
      h.splice(index, 1);
    } else {
      h.push(d.value);
    }
    setHistoricalDataYears(h);
  };

  return (
    <>
      {!isRename && (
        <div className="row mx-0 p-1 mb-2">
          <div className="col-lg-12 py-2 px-0">
            <h5 className="m-0">New</h5>
          </div>
          <div className="col-lg-12 py-2 px-0">
            <div className="Create_Forms_View">
              <ul>
                <li>
                  <div className="Single_FV01" onClick={handleShow}>
                    <div className="Single_FV01_pic">
                      <BiPlus />
                    </div>
                    <div className="Single_FV01_name">New Forms</div>
                  </div>
                </li>
                <li>
                  {/* <div className="Single_FV01">
                  <div className="Single_FV01_pic">
                    <BiFile></BiFile>
                  </div>
                  <div className="Single_FV01_name">
                    New Forms New Forms New Forms
                  </div>
                </div> */}
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton className="pb-2">
          <Modal.Title className="h5">
            {isRename ? "Update Form" : "Create new form"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated} onSubmit={handleCreateForm}>
            <div className="mb-2">
              <label htmlFor="title" className="form-label mb-1 ">
                Form title *
              </label>

              <input
                type="text"
                className="form-control form-control-sm"
                id="exampleFormControlInput1"
                onChange={(e) => setFormName(e.target.value)}
                value={formName}
                required
                disabled
              />
            </div>
            <div className="mb-2">
              <label htmlFor="desc" className="form-label mb-1">
                Description *
              </label>
              <textarea
                className="form-control form-select-sm"
                required
                onChange={(e) => setFormDesc(e.target.value)}
                defaultValue={formDesc}
                disabled
              ></textarea>
            </div>
            <div className="py-2">
              <label htmlFor="type" className="mb-1">Type</label>
              &nbsp;*
              <select
                className="form-select"
                required
                value={formTypeVal}
                disabled={isRename}>
                <option value="" disabled hidden>
                  Select
                </option>
                {FORMTYPES.map((type) => (
                  <option value={type.value} key={type.value}>
                    {type.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-2">
              <label htmlFor="language" className="form-label mb-1">
                Language *
              </label>
              <select
                // defaultValue={selLang}
                disabled={isRename ? "disabled" : ""}
                className="form-select form-select-sm"
                required
                onChange={(e) => setSelLanguage(e.target.value)}
                value={selLang}
              >
                <option value="">Select</option>
                {languages != null && languages !== undefined && languages.map((item) => (
                  <option value={item.id} key={item.id}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
            {(formTypeVal === ASSESSMENTFORMTXT || formTypeVal === GENERAL_FORM) &&
              <div className="mb-2">
                <div>
                  <label htmlFor="" className="form-label mb-1">Scoring method</label>
                  <select className='form-select w-100 form-select-sm' required id='scoringmethods'
                    onChange={(e) => setScoringMethod(e.target.value)} value={scoringmethod}>
                    {SCORINGMETHODS.map((opt) => (
                      <option key={opt.key} value={opt.key}>
                        {opt.name}
                      </option>
                    ))}
                  </select>
                  {scoringmethod != 'NONE' && <small className='desc-txt'>
                    Score of the section will be calculated as the <span className='text-lower'>{scoringmethod}</span> {scoringmethod == 'AVERAGE' && <span>score</span>} of all the questions in this section
                  </small>}
                </div>
              </div>
            }
            <div className="py-2">
              <input
                type="checkbox"
                className="form-check-input"
                id="reviewRequiredCheck"
                checked={reviewRequired}
                onChange={() => setReviewRequired(!reviewRequired)}
              />
              <label className="form-check-label px-1" htmlFor="reviewRequiredCheck">Data Approval Needed</label>
            </div>
            <div className="py-2">
              <input
                type="checkbox"
                checked={historicalDataSupported}
                className="form-check-input"
                id="hisDataRequiredCheck"
                onChange={() => setHistoricalDataSupported(!historicalDataSupported)}
              />
              <label className="form-check-label px-1" htmlFor="hisDataRequiredCheck">Support Historical Data</label>
            </div>
            {
              historicalDataSupported &&
              <div className="py-2">
                <label htmlFor="yearSelector">Years</label>
                <Multiselect
                  id="yearSelector"
                  key="yearSelector"
                  options={yearOptions}
                  displayValue="displayValue"
                  selectedValues={getSelectedYears()}
                  onSelect={(selectedList, selectedItem) => {
                    onSelectDeSelectYear(selectedItem);
                  }}
                  onRemove={(selectedList, selectedItem) => {
                    onSelectDeSelectYear(selectedItem);
                  }}
                />
              </div>
            }
            <div className="text-center p-2">
              {isRename ? (
                <button
                  type="submit"
                  className="btn btn-primary px-4 sbmBtn">
                  Update
                </button>
              ) : (
                <button
                  type="submit"
                  className="btn btn-primary px-4 sbmBtn">
                  Create
                </button>
              )}
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default FormCreate;
